import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecipientCriptoService {
  API_URL = environment.apiGatewayURL;

  constructor(private http: HttpClient) {}

  saveRecipientAccount(recipientAccount: any): Promise<any> {
    const serviceURL = `${this.API_URL}recipient/usdt/beneficiario-cripto`;
    return firstValueFrom(this.http.post<any>(serviceURL,recipientAccount));
  }
  getByUser(userId: number): Promise<any[]>{
    const serviceURL = `${this.API_URL}recipient/usdt/beneficiario-cripto/${userId}`;
    return firstValueFrom(this.http.get<any[]>(serviceURL));
  }
  inactivateAccount(accountId: number): Promise<any>{
    const serviceURL = `${this.API_URL}recipient/usdt/inactivate-beneficiario-cripto/${accountId}`;
    const body = { cuentaId: accountId };
    return firstValueFrom(this.http.put<any>(serviceURL, {}));
  }

  getTransactionCripto(currentPage: number, pageSize: number, medioCriptoId?: number | null, soloPorProcesar = false): Promise<any>{
    // Por defecto todo el historial: las enviadas y las que están en Binance se ven (solo con "Ver detalle").
    // `soloPorProcesar` pide solo POR_PROCESAR (`&estado=`): wallet-back filtra y cuenta, así el paginador cuadra.
    // `medioCriptoId` (1|2|3) filtra por la red del beneficiario; sin él, todas.
    const filtroEstado = soloPorProcesar ? '&estado=POR_PROCESAR' : '';
    const filtroRed = medioCriptoId ? `&medioCriptoId=${medioCriptoId}` : '';
    const serviceURL = `${this.API_URL}transaccion/transaccionUSDT?page=${currentPage}&pageSize=${pageSize}${filtroEstado}${filtroRed}`;
    return firstValueFrom(this.http.get<any[]>(serviceURL));
  }

  getTransactionCriptoManualTransactions(id: string): Promise<any>{
    const serviceURL = `${this.API_URL}transaccion/manual-related?id=${id}`;
    return firstValueFrom(this.http.get<any[]>(serviceURL));
  }

}
